import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { RingSizes } from '../ring/productMap';
import { buildAccessoryStoreConfig } from '../storeAliasHelper';

// PRODUCTION configuration
const TravelChargerProdConfig = buildAccessoryStoreConfig<RingSizes>({
  [ShopifyStore.IN]: {
    price: 3_799,
    variants: {
      [RingSizes.FIVE]: {
        variantId: '41655339319366',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655339319366',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655339319366:1',
      },
      [RingSizes.SIX]: {
        variantId: '41655339581510',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655339581510',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655339581510:1',
      },
      [RingSizes.SEVEN]: {
        variantId: '41655339876422',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655339876422',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/7521922023494:1',
      },
      [RingSizes.EIGHT]: {
        variantId: '41655340171334',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655340171334',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655340171334:1',
      },
      [RingSizes.NINE]: {
        variantId: '41655340400710',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655340400710',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655340400710:1',
      },
      [RingSizes.TEN]: {
        variantId: '41655340630086',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655340630086',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655340630086:1',
      },
      [RingSizes.ELEVEN]: {
        variantId: '41655340924998',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655340924998',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655340924998:1',
      },
      [RingSizes.TWELVE]: {
        variantId: '41655341154374',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655341154374',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655341154374:1',
      },
      [RingSizes.THIRTEEN]: {
        variantId: '41655341482054',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655341482054',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655341482054:1',
      },
      [RingSizes.FOURTEEN]: {
        variantId: '41655341711430',
        shopifyVariantId: 'gid://shopify/ProductVariant/41655341711430',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41655341711430:1',
      },
      [RingSizes.OPEN]: {
        variantId: '41662070980678',
        shopifyVariantId: 'gid://shopify/ProductVariant/41662070980678',
        checkoutUrl:
          'https://ultrahumanstore.myshopify.com/cart/41662070980678:1',
      },
    },
  },
  [ShopifyStore.AE]: {
    price: 169,
    variants: {
      [RingSizes.FIVE]: {
        variantId: '45975073292530',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975073292530',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975073292530:1',
      },
      [RingSizes.SIX]: {
        variantId: '45975073489138',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975073489138',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975073489138:1',
      },
      [RingSizes.SEVEN]: {
        variantId: '45975073685746',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975073685746',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975073685746:1',
      },
      [RingSizes.EIGHT]: {
        variantId: '45975073882354',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975073882354',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975073882354:1',
      },
      [RingSizes.NINE]: {
        variantId: '45975074078962',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975074078962',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975074078962:1',
      },
      [RingSizes.TEN]: {
        variantId: '45975074275570',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975074275570',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975074275570:1',
      },
      [RingSizes.ELEVEN]: {
        variantId: '45975074472178',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975074472178',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975074472178:1',
      },
      [RingSizes.TWELVE]: {
        variantId: '45975074668786',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975074668786',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975074668786:1',
      },
      [RingSizes.THIRTEEN]: {
        variantId: '45975074865394',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975074865394',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975074865394:1',
      },
      [RingSizes.FOURTEEN]: {
        variantId: '45975075062002',
        shopifyVariantId: 'gid://shopify/ProductVariant/45975075062002',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45975075062002:1',
      },
      [RingSizes.OPEN]: {
        variantId: '45988381950194',
        shopifyVariantId: 'gid://shopify/ProductVariant/45988381950194',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/45988381950194:1',
      },
    },
  },
  [ShopifyStore.US]: {
    price: 45,
    variants: {
      [RingSizes.FIVE]: {
        variantId: '40810822762592',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822762592',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822762592:1',
      },
      [RingSizes.SIX]: {
        variantId: '40810822795360',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822795360',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822795360:1',
      },
      [RingSizes.SEVEN]: {
        variantId: '40810822828128',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822828128',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822828128:1',
      },
      [RingSizes.EIGHT]: {
        variantId: '40810822860896',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822860896',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822860896:1',
      },
      [RingSizes.NINE]: {
        variantId: '40810822893664',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822893664',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822893664:1',
      },
      [RingSizes.TEN]: {
        variantId: '40810822926432',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822926432',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822926432:1',
      },
      [RingSizes.ELEVEN]: {
        variantId: '40810822959200',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822959200',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822959200:1',
      },
      [RingSizes.TWELVE]: {
        variantId: '40810822991968',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810822991968',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810822991968:1',
      },
      [RingSizes.THIRTEEN]: {
        variantId: '40810823024736',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810823024736',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810823024736:1',
      },
      [RingSizes.FOURTEEN]: {
        variantId: '40810823057504',
        shopifyVariantId: 'gid://shopify/ProductVariant/40810823057504',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40810823057504:1',
      },
      [RingSizes.OPEN]: {
        variantId: '40818980356192',
        shopifyVariantId: 'gid://shopify/ProductVariant/40818980356192',
        checkoutUrl:
          'https://stelcore-x-ultrahuman.myshopify.com/cart/40818980356192:1',
      },
    },
  },
  [ShopifyStore.CA]: {
    price: 69,
    // CA inherits all variants from US
  },
  [ShopifyStore.ROW]: {
    price: 45,
    variants: {
      [RingSizes.FIVE]: {
        variantId: '41619116523580',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619116523580',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619116523580:1',
      },
      [RingSizes.SIX]: {
        variantId: '41619116720188',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619116720188',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619116720188:1',
      },
      [RingSizes.SEVEN]: {
        variantId: '41619116916796',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619116916796',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619116916796:1',
      },
      [RingSizes.EIGHT]: {
        variantId: '41619117113404',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619117113404',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619117113404:1',
      },
      [RingSizes.NINE]: {
        variantId: '41619117310012',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619117310012',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619117310012:1',
      },
      [RingSizes.TEN]: {
        variantId: '41619117506620',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619117506620',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619117506620:1',
      },
      [RingSizes.ELEVEN]: {
        variantId: '41619117703228',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619117703228',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619117703228:1',
      },
      [RingSizes.TWELVE]: {
        variantId: '41619117899836',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619117899836',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619117899836:1',
      },
      [RingSizes.THIRTEEN]: {
        variantId: '41619118096444',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619118096444',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619118096444:1',
      },
      [RingSizes.FOURTEEN]: {
        variantId: '41619118293052',
        shopifyVariantId: 'gid://shopify/ProductVariant/41619118293052',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41619118293052:1',
      },
      [RingSizes.OPEN]: {
        variantId: '41630148132924',
        shopifyVariantId: 'gid://shopify/ProductVariant/41630148132924',
        checkoutUrl:
          'https://ultrahuman-us.myshopify.com/cart/41630148132924:1',
      },
    },
  },
  [ShopifyStore.EU]: {
    price: 42,
    variants: {
      [RingSizes.FIVE]: {
        variantId: '49621428109630',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621428109630',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621428109630:1?channel=buy_button',
      },
      [RingSizes.SIX]: {
        variantId: '49621428273470',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621428273470',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621428273470:1?channel=buy_button',
      },
      [RingSizes.SEVEN]: {
        variantId: '49621428437310',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621428437310',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621428437310:1?channel=buy_button',
      },
      [RingSizes.EIGHT]: {
        variantId: '49621428699454',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621428699454',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621428699454:1?channel=buy_button',
      },
      [RingSizes.NINE]: {
        variantId: '49621429190974',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621429190974',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621429190974:1?channel=buy_button',
      },
      [RingSizes.TEN]: {
        variantId: '49621429551422',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621429551422',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621429551422:1?channel=buy_button',
      },
      [RingSizes.ELEVEN]: {
        variantId: '49621429715262',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621429715262',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621429715262:1?channel=buy_button',
      },
      [RingSizes.TWELVE]: {
        variantId: '49621429879102',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621429879102',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621429879102:1?channel=buy_button',
      },
      [RingSizes.THIRTEEN]: {
        variantId: '49621430042942',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621430042942',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621430042942:1?channel=buy_button',
      },
      [RingSizes.FOURTEEN]: {
        variantId: '49621430206782',
        shopifyVariantId: 'gid://shopify/ProductVariant/49621430206782',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49621430206782:1?channel=buy_button',
      },
      [RingSizes.OPEN]: {
        variantId: '49633970487614',
        shopifyVariantId: 'gid://shopify/ProductVariant/49633970487614',
        checkoutUrl:
          'https://ultrahuman-eu-uk.myshopify.com/cart/49633970487614:1?channel=buy_button',
      },
    },
  },
  [ShopifyStore.GB]: {
    price: 39,
    // GB inherits all variants from EU
  },
  [ShopifyStore.AU]: {
    price: 69,
    // AU inherits all variants from EU
  },
  [ShopifyStore.SA]: { price: 194 },
  [ShopifyStore.MX]: { price: 761 },
  [ShopifyStore.ZA]: { price: 999 },
  [ShopifyStore.JP]: { price: 5_980 },
});

// STAGING/DEV configuration
const TravelChargerStagingConfig = buildAccessoryStoreConfig<RingSizes>({
  [ShopifyStore.IN]: {
    price: 3_799,
    variants: {
      [RingSizes.FIVE]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.SIX]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.SEVEN]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.EIGHT]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.NINE]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.TEN]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.ELEVEN]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.TWELVE]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.THIRTEEN]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.FOURTEEN]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
      [RingSizes.OPEN]: {
        variantId: '40570026983497',
        shopifyVariantId: 'gid://shopify/ProductVariant/40570026983497',
        checkoutUrl:
          'https://ultrahuman-mena.myshopify.com/cart/40570026983497:1',
      },
    },
  },
  [ShopifyStore.AE]: { price: 169 },
  [ShopifyStore.US]: { price: 45 },
  [ShopifyStore.CA]: { price: 69 },
  [ShopifyStore.ROW]: { price: 45 },
  [ShopifyStore.EU]: { price: 42 },
  [ShopifyStore.GB]: { price: 39 },
  [ShopifyStore.AU]: { price: 69 },
  [ShopifyStore.SA]: { price: 194 },
  [ShopifyStore.MX]: { price: 761 },
  [ShopifyStore.ZA]: { price: 999 },
  [ShopifyStore.JP]: { price: 5_980 },
});

export const TravelChargerShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? TravelChargerProdConfig
    : TravelChargerStagingConfig;

export function getTravelChargerPrice(
  store: ShopifyStore | null | undefined,
): number | null {
  if (!store) return null;
  const price = TravelChargerShopifyMap[store]?.price;
  if (typeof price === 'number') return price;
  const fallback = TravelChargerShopifyMap[ShopifyStore.ROW]?.price;
  return typeof fallback === 'number' ? fallback : null;
}
